import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function StatusBadge({ status }) {
  const isActive = status === '1';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: isActive ? '#E8F5E9' : '#F5F5F5',
        border: `1px solid ${isActive ? '#C8E6C9' : '#E0E0E0'}`,
        width: 'fit-content',
      }}
    >
      {/* Dot indicator */}
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: isActive ? '#43A047' : '#9E9E9E',
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 500,
          fontSize: '0.75rem',
          lineHeight: 1,
          color: isActive ? '#2E7D32' : '#616161',
          whiteSpace: 'nowrap',
        }}
      >
        {isActive ? 'Ativo' : 'Inativo'}
      </Typography>
    </Box>
  );
}

export default StatusBadge;
